import styled from "styled-components";

export const Container = styled.div`
  padding: ${(props) => props.theme.padding.mobile} 20px;

  @media (min-width: 640px) {
    padding: ${(props) => props.theme.padding.primary} 20px;
  }
`;

export const GoalsListWrapper = styled.div`
  width: 100%;
  max-width: 1120px;
  margin: 0 auto;

  > h1 {
    color: #2d2d2d;
    text-align: center;
    font-family: Mulish;
    font-size: 20px;
    font-style: normal;
    font-weight: 800;
    line-height: 24px;
    letter-spacing: 0.6px;
    margin-bottom: 36px;
  }
`;

export const WrapperButtons = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 24px;

  > :last-child {
    margin-left: auto;
  }
`;

export const TableWrapperItems = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  @media (min-width: 640px) {
    flex-direction: row;
  }
`;

export const TableElement = styled.p`
  color: #2d2d2d;
  font-size: 12px;
  font-style: normal;
  font-weight: 800 !important;
  line-height: 24px;
  letter-spacing: 0.36px;
  text-transform: uppercase;
  display: flex;
  gap: 4px;
  width: fit-content;

  > span {
    color: #595959;
    font-weight: 400;
  }
`;

export const ItemMobile = styled.div`
  padding: 8px 16px;
  border-radius: 5px;
  display: flex;
  height: fit-content;
  justify-content: space-between;
  align-items: center;
`;

export const Filter = styled.form`
  border-radius: 10px;
  border: 1px solid #9d9d9d;
  margin-bottom: 32px;
  padding: 32px 16px;
  display: flex;
  flex-direction: column;
  gap: 32px;

  > :last-child {
    display: flex;
    justify-content: end;
    align-items: center;
    gap: 16px;
  }

  @media (min-width: 640px) {
    display: grid;
    grid-template-columns: repeat(3, 1fr) 2fr;
  }
`;

export const WrapperActions = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 24px;
`;
